import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import {
    deviceDetails,
    deviceMismatch,
    graphPlotStorage,
    selecteInternalAcessories,
    showModal,
    webSerialConnect,
} from '../../../redux/actions'

import selectImg from '../../../Assets/img/select bar@2x.png'
import inputImg from '../../../Assets/img/assemble bar@2x.png'
import digitalImg from '../../../Assets/img/code bar@2x.png'
import flowchartImg from '../../../Assets/img/simulate bar@2x.png'

import secondaryImg from '../../../Assets/Bisoft_UI/Buttons/Inactive with shadow/save - secondary@2x.png'
import style from '../DialogModal/DialogModal.module.css'
import strokeImg from '../../../Assets/Bisoft_UI/Buttons/Inactive with shadow/help@2x.png'
import file from '../../../Assets/Bisoft_UI/Buttons/Inactive - without shadow/file.png'
import renderPrgImage from '../../../source/programImg'
import saveButton from '../../../Assets/Bisoft_UI/AppMode/save.png'
import renderImage from '../../../source/importImg'
import alignImage from '../../../Assets/flowchart/button 52x52 - stroke.png'
import { useHistory } from 'react-router'
import {
    connectSerialDevice,
    connectSerialDeviceInitial,
    connectSerialDeviceIntermediate,
    connectUSBDevice,
} from '../../WebSerialConnection/SerialUSBConnect'
import { portsData } from '../../Assembly/GraphPlotter/GraphPlotStorage'
import './ProgramHeader.css'
import { useState } from 'react'
import { saveAs } from 'file-saver'
import DialogModal from '../DialogModal/DialogModal'
import DeviceMissMatchPopupCom from './DeviceMissMatchPopupCom'
import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import html2canvas from 'html2canvas'
import SaveGraph from '../../Assembly/GraphPlotter/newGraphUi/SaveGraph'
import { width } from '../../../helpers/Sizes'
import { clearFlowChartIfPannelData } from '../../../utils/removeSensorProgramData'

function ProgramHeader({
    worker,
    webSerial,
    webSerialConnect,
    data,
    logic,
    showHelp,
    handleHelp,
    showSave,
    handleSave,
    showClear,
    handleClear,
    showFlowchartAlign,
    handleFlowchartAlign,
    showGraph,
    showModal,
    graph,
    viewActions,
    actionsList,
    device,
    deviceMismatch,
    deviceDetail,
    DeselectedComponent,
    concept,
    graphPlotStorage,
    graphPlotStorageReset,
    setSelectMultipleInternalAccessories,
    selecteComponent,
    logicComponent,
    stopPA = () => {},
    // musicDisable,
    // toggleSwipeBtnHandel = () => {},
    // isAudioEnable = true,
    isShowNewUI,
    socketData,
    fileSaveClick = () => {},
    isShowProjectName = false,
    projectName = 'Name',
    setCreateActionState = () => {},
    isSaveToBoard = false,
    chartRef,
    styles = {},
    isShowBack = false,
    isShowTitle = false,
    goBack = () => {},
    singleTitle = '',
}) {
    var GraphData = JSON.parse(sessionStorage.getItem('GraphData'))
    let SELECTBARS = {
        0: (
            <img
                src={GraphData == true ? inputImg : selectImg}
                style={
                    GraphData == true
                        ? {
                              height: '100%',
                              width: '23%',
                              position: 'relative',
                              right: '42vw',
                          }
                        : {
                              height: '100%',
                              width: '17%',
                              position: 'relative',
                              right: '43vw',
                          }
                }
            />
        ),
        1: (
            <img
                src={GraphData == true ? flowchartImg : inputImg}
                style={
                    GraphData == true
                        ? {
                              height: '100%',
                              width: '55%',
                              position: 'relative',
                              right: '42vw',
                          }
                        : {
                              height: '100%',
                              width: '29%',
                              position: 'relative',
                              right: '38vw',
                          }
                }
            />
        ),
        2: (
            <img
                src={digitalImg}
                style={
                    GraphData == true
                        ? {
                              height: '100%',
                              width: '40%',
                              position: 'relative',
                              right: '38vw',
                          }
                        : {
                              height: '100%',
                              width: '40%',
                              position: 'relative',
                              right: '31vw',
                          }
                }
            />
        ),
        3: (
            <img
                src={flowchartImg}
                style={
                    GraphData == true
                        ? {
                              height: '100%',
                              width: '52%',
                              position: 'relative',
                              right: '33vw',
                          }
                        : {
                              height: '100%',
                              width: '52%',
                              position: 'relative',
                              right: '25vw',
                          }
                }
            />
        ),

        4: (
            <img
                src={flowchartImg}
                style={
                    GraphData == true
                        ? {
                              height: '100%',
                              width: '55%',
                              position: 'relative',
                              right: '25vw',
                          }
                        : null
                }
            />
        ),
    }
    // const [fileName, setFileName] = useState('')
    // const [filePopup, setFilePopUp] = useState(false)
    // const [isDeviceMismatch, setIsDeviceMismatch] = useState(false)
    // const [showErrorMsg, setShowErrorMsg] = useState(false)
    const [valueName, setValueName] = useState(projectName)
    const [showInputName, setShowInputName] = useState(false)
    const [selectedRunGraph, setSelectedRunGraph] = useState('select')
    const [plotData1, setPlotData1] = useState([])
    const [showErrorMessage, setShowErrorMessage] = useState({
        show: false,
        message: '',
    })
    const [showDialogBoxes, setShowDialogBoxes] = useState({
        showErrorMsg: false,
        isDeviceMismatch: false,
        filePopup: false,
    })
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const deviceVersion = sessionStorage.getItem('deviceVersion')
    const inputNameRef = useRef(null)
    let history = useHistory()
    var newFileName = ''

    let deviceName = ''
    switch (connectedDevice) {
        case 'Hexapod':
            deviceName = 'Crawl-e'
            break
        default:
            deviceName = 'Zing'
    }

    useEffect(() => {
        setValueName(projectName)
    }, [projectName])

    const handleUSB = async () => {
        if (!webSerial.isConnected) {
            let res = await connectSerialDeviceIntermediate(
                { isAutomatic: false },
                worker,
                socketData
            )

            if (res !== undefined) {
                if (!res.isPortOpen) {
                    deviceMismatch({
                        deviceMismatched: res.matchedObj_with_Version,
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: true,
                    })
                } else {
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: false,
                    })
                    deviceMismatch({
                        deviceMismatched: {},
                        isMemoryPresent: res.isMemoryPresent,
                        isArmError: res.isArmError,
                        is2In1Sensor: res.is2In1Sensor,
                        plodeNativeData: {
                            ...device.plodeNativeData,
                            mountPoint: res.mountPoint,
                        },
                    })
                }

                if (res.is2In1Sensor) {
                    graphPlotStorageReset({
                        isColorSensor: false,
                        isRedLight: false,
                        isGreenLight: false,
                        isBlueLight: false,
                        isGestureSensor: false,
                    })
                    setSelectMultipleInternalAccessories({
                        isRedLight: false,
                        isBlueLight: false,
                        isGreenLight: false,
                        isGestureSensor: false,
                    })
                    DeselectedComponent({
                        isColorSensor: false,
                        isGestureSensor: false,
                    })

                    const removeReduxLogicState = (program) => {
                        program.map((data) => {
                            if (data.type === 'sensor') {
                                let dataSorce = data?.state?.source?.replace(
                                    /\s+/g,
                                    '_'
                                )
                                if (
                                    [
                                        '4-IN-1_SENSOR_→_RED',
                                        '4-IN-1_SENSOR_→_BLUE',
                                        '4-IN-1_SENSOR_→_GREEN',
                                        '4-IN-1_SENSOR_→_GESTURE',
                                    ].includes(dataSorce)
                                ) {
                                    data.state.source = ''
                                    data.state.value = 0
                                    data.state.value2 = 0
                                    data.state.condition = ''
                                }

                                data.subprogram = removeReduxLogicState(
                                    data.subprogram
                                )
                            }
                        })

                        return program
                    }

                    if (logic?.program) {
                        let newLogic = { ...logic }
                        newLogic.program = removeReduxLogicState(
                            newLogic.program
                        )

                        logicComponent(newLogic)
                    }

                    if (
                        sessionStorage.getItem('programMode') ===
                        'flowchartBased'
                    ) {
                        clearFlowChartIfPannelData(
                            sessionStorage.getItem('flowchart-elements'),
                            [
                                'colorSensorRed',
                                'colorSensorGreen',
                                'colorSensorBlue',
                                'gestureSensor',
                            ]
                        )

                        sessionStorage.setItem('isColorSensor', false)
                        sessionStorage.setItem('isGestureSensor', false)
                    }
                }
            }

            if (res) {
                webSerialConnect({ port: res.port })
            } else {
                setShowDialogBoxes({ ...showDialogBoxes, showErrorMsg: true })
            }
        }
    }

    //for mismatch of device while connecting
    const handleDevice = async (option) => {
        if (option === 'no') {
            let port = webSerial.port
            //is this needed??
            // await openSerialReadComPort(port,worker)
        } else {
            shouldErase()
            history.push('/Selection')
            let mismatchedDevice = device.deviceMismatched
            sessionStorage.setItem('connectedDevice', mismatchedDevice.id)
            // if (['Ace','Hexapod'].includes(mismatchedDevice.id)) {
            sessionStorage.setItem('deviceVersion', mismatchedDevice.version)
            if (webSerial.isConnected)
                sessionStorage.setItem('isDeviceConnected', true)
            deviceDetail({
                connectedDevice: mismatchedDevice.id,
                deviceVersion: mismatchedDevice.version,
            })
            // } else {
            //     sessionStorage.setItem('zingVersion', mismatchedDevice.version)
            //     deviceDetail({
            //         connectedDevice: mismatchedDevice.id,
            //         zingVersion: mismatchedDevice.version,
            //         deviceVersion: '0.0.0',
            //     })
            // }
        }
        setShowDialogBoxes({ ...showDialogBoxes, isDeviceMismatch: false })
        deviceMismatch({ deviceMismatched: {} })
    }

    const shouldErase = () => {
        let programMode = sessionStorage.programMode
        let connectedDevice = sessionStorage.connectedDevice
        let version = sessionStorage.deviceVersion
        let recoveryData = JSON.parse(localStorage.getItem('recoveryData'))
        if (
            localStorage.getItem('recoveryData') !== null &&
            programMode in recoveryData &&
            connectedDevice in recoveryData[programMode] &&
            version in recoveryData[programMode][connectedDevice]
        ) {
            if (Object.keys(recoveryData).length === 1) {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        localStorage.removeItem('recoveryData')
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                        localStorage.setItem(
                            'recoveryData',
                            JSON.stringify(recoveryData)
                        )
                    }
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            } else {
                if (Object.keys(recoveryData[programMode]).length === 1) {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                } else {
                    if (
                        Object.keys(recoveryData[programMode][connectedDevice])
                            .length === 1
                    ) {
                        delete recoveryData[programMode][connectedDevice]
                    } else {
                        delete recoveryData[programMode][connectedDevice][
                            version
                        ]
                    }
                    localStorage.setItem(
                        'recoveryData',
                        JSON.stringify(recoveryData)
                    )
                }
            }
        }
        var arr = Object.keys(sessionStorage)
        for (const i of arr) {
            if (
                i != 'connectedDevice' &&
                i != 'Hardware' &&
                i != 'userData' &&
                i != 'concept' &&
                i != 'webSerialPortList' &&
                i != 'user' &&
                i != 'deviceVersion' &&
                i != 'programMode' &&
                i != 'isWindowOnFocus' &&
                i != 'slideDirection' &&
                i != 'versionData' &&
                i != 'coverflowActive'
            ) {
                //arr.push(i);
                sessionStorage.removeItem(i)
                // console.log(i, "sess");
            }
        }
        sessionStorage.setItem('pip', false)
        sessionStorage.setItem('name', 'null')
        sessionStorage.setItem('GraphData', false)
        sessionStorage.setItem('shield', 'false')
        sessionStorage.setItem('peeCeeATR', 'false')
        sessionStorage.setItem('arm_shield', 'false')
        sessionStorage.setItem('slideDirection', true)
        concept.Index = []
        concept.counter = []
        DeselectedComponent({
            Four_in_one_sensor: {
                isDistanceSensors: false,
                isGestureSensor: false,
                isLightSensor: false,
                isColorSensor: false,
            },
            isFour_in_one_sensor: false,

            // input
            isTouchZero: false,
            isTouchOne: false,
            isTouchTwo: false,
            isTouchThree: false,
            // output
            isTouchZeroOutput: false,
            isTouchOneOutput: false,
            isTouchTwoOutput: false,
            isTouchThreeOutput: false,

            isMic: false,
            isTemperature: false,
            isBattery: false,
            isAccelerometer: false,

            isLeftEye: false,
            isRightEye: false,
            isEYES: false,
            isbuzzer: false,

            isSmileOne: false,
            isSmileTwo: false,
            isSmileThree: false,
            isSmileFour: false,
            //humanoid
            isBattery: false,
            isUltrasonic: false,
            isAccelerometer: false,
            isGyroX: false,
            isGyroY: false,
            isGyroZ: false,
            isAccelerometerX: false,
            isUltrasonic: false,
            isAccelerometerY: false,
            isAccelerometerZ: false,
            // output
            isLeftRGB: false,
            isRightRGB: false,
            isMp3: false,
            isHeadServo: false,
            isIndivdualServo: false,
            isActionGroup: false,
            isM1: false,
            isM2: false,
            isSimpleServo: false,
        })
        DeselectedComponent({
            portsData: [
                {
                    key: 'A',
                    ports: [
                        {
                            portName: 'A1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#E25432',
                        },
                        {
                            portName: 'A2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#B0D745',
                        },
                    ],
                },

                {
                    key: 'B',
                    ports: [
                        {
                            portName: 'B1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#23DE93',
                        },
                        {
                            portName: 'B2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#3A3A3A',
                        },
                    ],
                },

                {
                    key: 'C',
                    ports: [
                        {
                            portName: 'C1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#0ACEF7',
                        },
                        {
                            portName: 'C2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#5061A8',
                        },
                    ],
                },

                {
                    key: 'D',
                    ports: [
                        {
                            portName: 'D1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#0E3C11',
                        },
                        {
                            portName: 'D2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#DD1624',
                        },
                    ],
                },

                {
                    key: 'E',
                    ports: [
                        {
                            portName: 'E1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#F79B47',
                        },
                        {
                            portName: 'E2',
                            isActive: false,
                            isDigital: false,
                            isColor: '#F666D0',
                        },
                    ],
                },

                {
                    key: 'F',
                    ports: [
                        {
                            portName: 'F1',
                            isActive: false,
                            isDigital: false,
                            isColor: '#3D5B53',
                        },
                        {
                            portName: 'F2',
                            isActive: false,
                            isDigital: false,
                            isColor: 'black',
                        },
                    ],
                },
            ],
        })
        graphPlotStorageReset({
            time: { h: 0, m: 0, s: 0, ms: 0 },
            Four_in_one_sensor: {
                isDistanceSensors: false,
                isGestureSensor: false,
                isLightSensor: false,
                isColorSensor: false,
            },

            // input
            isTouchZero: false,
            isTouchOne: false,
            isTouchTwo: false,
            isTouchThree: false,
            isMic: false,
            isTemperature: false,
            isBattery: false,
            isAccelerometer: false,
            isAccelerometerX: false,
            isAccelerometerY: false,
            isAccelerometerZ: false,
            isGyroX: false,
            isGyroY: false,
            isGyroZ: false,
            isUltrasonic: false,
            portsData,
        })
        portsData[0] = {
            key: 'A',
            ports: [
                {
                    portName: 'A1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#E25432',
                },
                {
                    portName: 'A2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#B0D745',
                },
            ],
        }

        portsData[1] = {
            key: 'B',
            ports: [
                {
                    portName: 'B1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#23DE93',
                },
                {
                    portName: 'B2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#3A3A3A',
                },
            ],
        }

        portsData[2] = {
            key: 'C',
            ports: [
                {
                    portName: 'C1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#0ACEF7',
                },
                {
                    portName: 'C2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#5061A8',
                },
            ],
        }

        portsData[3] = {
            key: 'D',
            ports: [
                {
                    portName: 'D1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#0E3C11',
                },
                {
                    portName: 'D2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#DD1624',
                },
            ],
        }

        portsData[4] = {
            key: 'E',
            ports: [
                {
                    portName: 'E1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#F79B47',
                },
                {
                    portName: 'E2',
                    isActive: false,
                    isDigital: false,
                    isColor: '#F666D0',
                },
            ],
        }

        portsData[5] = {
            key: 'F',
            ports: [
                {
                    portName: 'F1',
                    isActive: false,
                    isDigital: false,
                    isColor: '#3D5B53',
                },
                {
                    portName: 'F2',
                    isActive: false,
                    isDigital: false,
                    isColor: 'black',
                },
            ],
        }
    }
    const handleError = async () => {
        setShowDialogBoxes({ ...showDialogBoxes, showErrorMsg: false })
        window.location.reload()
    }

    //when device is disconnect set the mismatch empty
    useEffect(() => {
        if (sessionStorage.getItem('isDeviceConnected') == 'false') {
            setShowDialogBoxes({
                ...showDialogBoxes,
                isDeviceMismatch: false,
            })
            deviceMismatch({ deviceMismatched: {} })
        }
    }, [webSerial.isConnected])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                inputNameRef.current &&
                !inputNameRef.current.contains(event.target)
            )
                setName()
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [valueName])
    useEffect(() => {
        if (device) {
            let deviceD = Object.keys(device.deviceMismatched)
            if (deviceD.length > 1) {
                if (showDialogBoxes.isDeviceMismatch == false) {
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: true,
                    })
                }
            }
        }
    }, [device.deviceMismatched])

    const saveFile = () => {
        sessionStorage.setItem('isSave', JSON.stringify(true))
        if (graph) {
            console.log(graph, 'hello')
            const csvHeader = Object.keys(graph[0]).join(',')
            const csvRows = graph
                .map((obj) => Object.values(obj).join(','))
                .join('\n')
            const csvString = `${csvHeader}\n${csvRows}`
            const blob = new Blob([csvString], { type: 'text/csv' })
            if (newFileName.length !== 0) saveAs(blob, `${newFileName}.csv`)
            return
        }

        const fileData = JSON.stringify(sessionStorage)
        const blob = new Blob([fileData], { type: 'text/plain' })
        if (newFileName.length !== 0) saveAs(blob, `${newFileName}.pld`)
    }

    //condition to show the dilogModel for zing v2 and cralwe v2 memory card present or not
    // or show the arm for zing has wrong position dilogModel condition.
    const isShowMemoryCardModel = () => {
        const path = window.location.pathname
        const isDeviceVersion2 = ['2', '3'].includes(deviceVersion?.[0])
        const isWebSerialConnected = webSerial.isConnected
        const isDeviceMismatch = showDialogBoxes.isDeviceMismatch
        const isMemoryError = !device.isMemoryPresent || device.isArmError

        const validConditions =
            isDeviceVersion2 &&
            isWebSerialConnected &&
            !isDeviceMismatch &&
            isMemoryError

        const deviceConditions = {
            Humanoid: validConditions,
            Hexapod:
                validConditions &&
                [
                    '/code/project/action/select',
                    '/code/project/action/create',
                ].includes(path),
        }

        return deviceConditions?.[connectedDevice] || false
    }

    const setName = () => {
        if (valueName.trim().length === 0 || valueName.trim().length > 10) {
            setShowErrorMessage({
                message: 'File name content minimum 1 to maximum 10 character.',
                show: true,
            })
            setTimeout(() => {
                setShowErrorMessage({
                    message: '',
                    show: false,
                })
            }, 2000)
            return
        }
        const validNamePattern = /^[a-zA-Z_$][a-zA-Z0-9_$]*$/
        if (!validNamePattern.test(valueName.trim())) {
            setShowErrorMessage({
                message: 'This is not a valid file name.',
                show: true,
            })
            setTimeout(() => {
                setShowErrorMessage({
                    message: '',
                    show: false,
                })
            }, 2000)
            return
        }
        setCreateActionState((prev) => {
            return { ...prev, projectName: valueName.trim() }
        })
        setShowInputName(false)
    }

    const handelSubmitName = (e) => {
        e.preventDefault()
        setName()
    }

    const RenderFileName = () => {
        console.log('onClock')
        const [fileName, setFileName] = useState('')

        let inputHandler = (event) => {
            setFileName(event.target.value)
            newFileName = event.target.value
        }
        console.log('newfile', newFileName)

        const handelGraphRunChange = (e) => {
            setSelectedRunGraph(e.target.value)

            const newSelectedRunGraph = e.target.value
            let newPlotData = []
            if (newSelectedRunGraph === 'selectAll') {
                Object.keys(graphPlotStorage?.graphRunInfo).map((objKey) => {
                    newPlotData = [
                        ...newPlotData,
                        ...graphPlotStorage?.graphRunInfo?.[objKey].plotData,
                    ]
                })
            } else {
                newPlotData =
                    graphPlotStorage?.graphRunInfo?.[newSelectedRunGraph]
                        ?.plotData || []
            }
            setPlotData1(newPlotData)
        }

        //handel graph data save as Excel
        const saveAsExcel = () => {
            if (selectedRunGraph === 'select' && !fileName) {
                return
            }

            const worksheet = XLSX.utils.json_to_sheet(plotData1)
            const workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook, worksheet, 'GraphData')
            XLSX.writeFile(workbook, `${fileName}.xlsx`)
            setShowDialogBoxes({
                showErrorMsg: false,
                isDeviceMismatch: false,
                filePopup: false,
            })
        }

        //handel graph data save as pdf
        const saveAsPdf = () => {
            if (selectedRunGraph === 'select' && !fileName) {
                return
            }
            let plotData = []
            if (selectedRunGraph === 'selectAll') {
                Object.keys(graphPlotStorage?.graphRunInfo).map((objKey) => {
                    plotData = [
                        ...plotData,
                        ...graphPlotStorage?.graphRunInfo?.[objKey].plotData,
                    ]
                })
            } else {
                plotData =
                    graphPlotStorage?.graphRunInfo?.[selectedRunGraph]
                        ?.plotData || []
            }
            const doc = new jsPDF()
            const headers = [Object.keys(plotData[0])]
            const rows = plotData.map((row) => Object.values(row))
            doc.text('Graph Data Report', 14, 15)
            autoTable(doc, {
                startY: 20,
                head: headers,
                body: rows,
            })
            doc.save(`${fileName}.pdf`)
            setShowDialogBoxes({
                showErrorMsg: false,
                isDeviceMismatch: false,
                filePopup: false,
            })
        }

        // const saveAsPdf = async () => {
        //     const chartElement = chartRef.current
        //     if (!chartElement) return

        //     // Clone chart content for full rendering
        //     const clonedChart = chartElement.cloneNode(true)
        //     document.body.appendChild(clonedChart)

        //     // Remove scroll to show full width
        //     clonedChart.style.overflow = 'visible'
        //     clonedChart.style.position = 'absolute'
        //     clonedChart.style.left = '-9999px' // hide from view

        //     // Get the internal wide chart container
        //     const wideChartContainer = clonedChart.querySelector('div')
        //     if (!wideChartContainer) {
        //         console.error('Failed to locate chart content')
        //         document.body.removeChild(clonedChart)
        //         return
        //     }

        //     // Wait for rendering to complete (in some edge cases)
        //     await new Promise((resolve) => setTimeout(resolve, 100))

        //     // Use html2canvas to capture the wide chart
        //     const canvas = await html2canvas(wideChartContainer, {
        //         scale: 2, // Better resolution
        //         useCORS: true,
        //     })

        //     const imgData = canvas.toDataURL('image/png')
        //     const imgWidth = canvas.width
        //     const imgHeight = canvas.height

        //     // Create a PDF with custom size equal to image size
        //     const pdf = new jsPDF({
        //         orientation: 'landscape',
        //         unit: 'px',
        //         format: [imgWidth, imgHeight],
        //     })

        //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight)
        //     pdf.save('full-graph.pdf')

        //     // Clean up
        //     document.body.removeChild(clonedChart)
        // }

        return (
            <>
                {showDialogBoxes.filePopup && (
                    <div className={style.container}>
                        <div
                            className={style.box}
                            style={{
                                alignItems: 'center',
                                // width: graph ? 'auto' : '',
                            }}
                        >
                            <img
                                className={style.closeBtn}
                                style={{ width: '2.5rem' }} // top: '-60px'
                                src={renderImage('clos')}
                                onClick={() => {
                                    setShowDialogBoxes({
                                        ...showDialogBoxes,
                                        filePopup: false,
                                    })
                                }}
                            />
                            {graph && (
                                <div>
                                    <p>Select Run Export</p>
                                    {graphPlotStorage?.graphRunInfo &&
                                    Object.keys(graphPlotStorage?.graphRunInfo)
                                        ?.length > 0 ? (
                                        <select
                                            value={selectedRunGraph}
                                            className="headerRunDropDown"
                                            onChange={handelGraphRunChange}
                                        >
                                            <option value="select">
                                                Select
                                            </option>
                                            {Object.keys(
                                                graphPlotStorage?.graphRunInfo
                                            )?.map((objKey) => (
                                                <option
                                                    key={objKey}
                                                    value={objKey}
                                                >
                                                    {
                                                        graphPlotStorage
                                                            ?.graphRunInfo?.[
                                                            objKey
                                                        ]?.label
                                                    }
                                                </option>
                                            ))}
                                            <option value="selectAll">
                                                All Data
                                            </option>
                                        </select>
                                    ) : (
                                        <div className="headerRunDropDown">
                                            No Data
                                        </div>
                                    )}
                                </div>
                            )}
                            <input
                                placeholder="Enter the file name"
                                style={{
                                    width: '15vw',
                                    height: '4.5vh',
                                    backgroundColor: 'lightgrey',
                                    textAlign: 'center',
                                    // position: 'absolute',
                                    borderRadius: '5px',
                                    border: 'none',
                                    // top: '47%',
                                    // left: '50%',
                                    // transform: 'translate(-50%,-50%)',
                                }}
                                type="text"
                                value={fileName}
                                autoFocus={true}
                                onChange={inputHandler}
                            />{' '}
                            <br></br>
                            {!graph && (
                                <img
                                    src={saveButton}
                                    draggable="false"
                                    style={{
                                        cursor: 'pointer',
                                        width: '8vw',
                                        // position: 'absolute',
                                        // top: '54%',
                                        // left: '50%',
                                        // transform: 'translate(-50%,-50%)',
                                    }}
                                    onClick={() => {
                                        setShowDialogBoxes({
                                            ...showDialogBoxes,
                                            filePopup: false,
                                        })
                                        saveFile()
                                    }}
                                />
                            )}
                            {/* {graph && <SaveGraph plotData={plotData1} />} */}
                            {graph && (
                                <div className="headerPdfSaveBtnDiv">
                                    <button
                                        onClick={saveAsPdf}
                                        className="headerPdfSaveBtn"
                                    >
                                        Save as PDF
                                    </button>
                                    <button
                                        onClick={saveAsExcel}
                                        className="headerPdfSaveBtn"
                                    >
                                        Save as Excel
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </>
        )
    }
    const handleGraph = () => {
        history.push('/graphPlotter')
    }

    return (
        <>
            <DialogModal
                mismatchShow={showDialogBoxes.isDeviceMismatch}
                text={<DeviceMissMatchPopupCom />}
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        isDeviceMismatch: false,
                    })
                }
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => handleDevice('yes'),
                    },
                    // {
                    //     text: 'NO',
                    //     do: () => handleDevice('no'),
                    // },
                ]}
            />
            <DialogModal
                mismatchShow={isShowMemoryCardModel()}
                text={
                    !device.isMemoryPresent
                        ? `There is no memory card inserted in ${deviceName}. \nkindly insert one to use the application further.`
                        : device.isArmError
                          ? `The ${deviceName} hand is not proper position. \nkindly place the hand correct position.`
                          : ''
                }
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () =>
                            history.push(
                                connectedDevice === 'Hexapod'
                                    ? '/code/project/'
                                    : '/kitSelection'
                            ),
                    },
                ]}
            />
            <DialogModal
                showError={showDialogBoxes.showErrorMsg}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2.5vh',
                            }}
                        >
                            Error in connecting the device!
                        </p>
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2vh',
                            }}
                        >
                            Please disconnect the device and try connecting
                            again.
                        </p>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowDialogBoxes({
                        ...showDialogBoxes,
                        showErrorMsg: false,
                    })
                }
                optionsToSelect={[
                    {
                        text: 'OK',
                        do: handleError,
                    },
                ]}
            />

            <div className="HeaderContainer">
                <RenderFileName />
                <div
                    className="flowchart-navbarContainer navbarContainer"
                    style={{ zIndex: '1000', ...styles?.headerBar }}
                >
                    {SELECTBARS[data.selected]}
                    {data.options && (
                        <div className="flowchart-navbar_content navbar_content">
                            {data.options.map((option, index) => (
                                <div
                                    key={index}
                                    className={`flowchart-navbar_new navbar_new ${
                                        data.selected <= index - 1
                                            ? 'notActive'
                                            : 'isActive'
                                    }`}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        // isShowProjectName && showInputName
                                        //     ? 'left'
                                        //     : 'center',
                                        justifyContent:
                                            isShowProjectName && showInputName
                                                ? 'left'
                                                : 'center',
                                    }}
                                >
                                    {isShowProjectName &&
                                    isShowNewUI &&
                                    index === 0 ? (
                                        <div className="programHeaderNameDiv">
                                            {!showInputName ? (
                                                <div className="programHeaderNameInnerDiv">
                                                    <p
                                                        style={{
                                                            marginBottom: '0',
                                                        }}
                                                    >
                                                        {valueName}
                                                    </p>
                                                    <img
                                                        src={renderImage(
                                                            'edit'
                                                        )}
                                                        alt="editBtn"
                                                        onClick={() =>
                                                            setShowInputName(
                                                                true
                                                            )
                                                        }
                                                    />
                                                </div>
                                            ) : (
                                                <form
                                                    onSubmit={handelSubmitName}
                                                >
                                                    <input
                                                        ref={inputNameRef}
                                                        type="text"
                                                        value={valueName}
                                                        onChange={(e) =>
                                                            setValueName(
                                                                e.target.value
                                                            )
                                                        }
                                                    />

                                                    {showErrorMessage.show && (
                                                        <p className="actionProjectNameError">
                                                            {
                                                                showErrorMessage.message
                                                            }
                                                        </p>
                                                    )}
                                                </form>
                                            )}
                                        </div>
                                    ) : (
                                        option
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {isShowTitle && (
                        <div
                            style={{
                                position: 'absolute',
                                height: '90%',
                                width: '32%',
                                // border: '1px solid red',
                                position: 'absolute',
                                // right: '0%',
                                left: '2%',
                                top: '53%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexDirection: 'row',
                                flexWrap: 'nowrap',
                                alignItems: 'center',
                            }}
                        >
                            {/* {isShowBack && (
                            <div
                                className="help_button"
                                style={{
                                    position: 'relative',
                                    height: '9vh',
                                }}
                            >
                                <img
                                    style={{
                                        position: 'absolute',
                                        height: '9vh',
                                        top: '11%',
                                        cursor: 'pointer',
                                    }}
                                    src={renderImage('backBtn')}
                                    onClick={() => {
                                        if (goBack) {
                                            goBack()
                                        } else history.goBack()
                                    }}
                                ></img>
                            </div>
                        )} */}

                            {isShowTitle && (
                                <div
                                    className="help_button"
                                    style={{
                                        // position: 'relative',
                                        // height: '9vh',
                                        // border: '1px solid red',
                                        // marginLeft: '12vh',
                                        fontSize: '20px',
                                    }}
                                >
                                    <p
                                        style={{
                                            // position: 'absolute',
                                            // height: '9vh',
                                            // top: '11%',
                                            marginBottom: '0',
                                        }}
                                    >
                                        {/* Project title 1 demo project */}
                                        {singleTitle}
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    <div
                        className="flowchart-navbar-Action navbar-Action"
                        style={{ alignItems: 'center' }}
                    >
                        {showGraph && (
                            <img
                                className="flowchart-iconBtnSize iconBtnSize"
                                style={{
                                    width: '61px',
                                    height: '61px',
                                    marginRight: '10px',
                                    marginTop: '-13px',
                                }}
                                src={renderPrgImage('graphbtn')}
                                onClick={handleGraph}
                            ></img>
                        )}

                        {showSave && (
                            <div
                                className="help_button"
                                style={{
                                    position: 'relative',
                                    width: '61px',
                                    height: '61px',
                                }}
                            >
                                <img
                                    className=" iconBtnSize" //flowchart-iconBtnSize
                                    style={{
                                        position: 'absolute',
                                        width: '61px',
                                        height: '61px',
                                        left: '0vw',
                                        bottom: '-4px',

                                        // marginRight: '10px',
                                        // marginTop: '-13px',
                                    }}
                                    src={secondaryImg}
                                    onClick={() => {
                                        if (isShowNewUI || isSaveToBoard) {
                                            fileSaveClick()
                                            return
                                        }
                                        stopPA()
                                        setShowDialogBoxes({
                                            ...showDialogBoxes,
                                            filePopup: true,
                                        })
                                    }}
                                ></img>
                                <span className="tooltiptext saveTooltiptext">
                                    {' '}
                                    <p>Save</p>
                                </span>
                            </div>
                        )}
                        {showFlowchartAlign && (
                            <div
                                className="help_button"
                                style={{ position: 'relative' }}
                            >
                                <img
                                    style={{
                                        width: '61px',
                                        height: '61px',
                                        marginRight: '10px',
                                        marginTop: '6px',
                                    }}
                                    src={alignImage}
                                    onClick={handleFlowchartAlign}
                                ></img>
                                <span
                                    className="tooltiptext"
                                    style={{ top: '14.5vh' }}
                                >
                                    {' '}
                                    <p>Align</p>
                                </span>
                            </div>
                        )}
                        {showClear && (
                            <div
                                className="help_button"
                                style={{
                                    position: 'relative',
                                    width: '60px',
                                    height: '60px',
                                }}
                            >
                                <img
                                    className="iconBtnSize"
                                    src={renderPrgImage('clearProgram')}
                                    onClick={handleClear}
                                    style={{
                                        position: 'absolute',
                                        width: '60px',
                                        height: '60px',
                                        left: '0vw',
                                        bottom: '2px',

                                        // marginRight: '10px',
                                        // marginTop: '-5px',
                                        transform: 'scale(0.78)',
                                    }}
                                ></img>
                                <span className="tooltiptext clearTooltiptext">
                                    {' '}
                                    <p>Clear</p>
                                </span>
                            </div>
                        )}
                        {showHelp && (
                            <div
                                className="help_button"
                                style={{
                                    position: 'relative',
                                    width: '61px',
                                    height: '61px',
                                }}
                            >
                                <img
                                    className=" iconBtnSize" //flowchart-iconBtnSize
                                    style={{
                                        position: 'absolute',
                                        width: '61px',
                                        height: '61px',
                                        left: '0vw',
                                        bottom: '-4px',
                                    }}
                                    src={strokeImg}
                                    onClick={handleHelp}
                                ></img>
                                <span className="tooltiptext saveTooltiptext">
                                    {' '}
                                    <p>Help</p>
                                </span>
                            </div>
                        )}
                        {/* {musicDisable && (
                            <div
                                className="musicNoteBtn"
                                style={{
                                    display: 'flex',
                                    position: 'relative',
                                    right: '0vw',
                                    // top: '10px',
                                }}
                            >
                                <div
                                    className={`swipe-container ${
                                        isAudioEnable ? '' : 'swipeBtn-true'
                                    }`}
                                    onClick={(e) => toggleSwipeBtnHandel(e)}
                                >
                                    <div className="swipe-handle"></div>
                                    <div className="swipeBtn-left-text">
                                        Audio Enable
                                    </div>
                                    <div className="swipeBtn-right-text">
                                        Audio Disable
                                    </div>
                                </div>

                                <span
                                    className="tooltiptext"
                                    style={{ width: '100' }}
                                >
                                    {' '}
                                    <p>Music Enable/Disable</p>
                                </span>
                            </div>
                        )} */}

                        {viewActions && (
                            <div
                                className="file_open"
                                style={{
                                    position: 'relative',
                                    width: '61px',
                                    height: '61px',

                                    // right: '0vw',
                                    // top: '10px',
                                    // border: ' 1px solid #000',
                                }}
                            >
                                <img
                                    // className="flowchart-iconBtnSize iconBtnSize"
                                    style={{
                                        position: 'absolute',
                                        width: '61px',
                                        height: '61px',
                                        left: '0vw',
                                        bottom: '-4px',
                                        // marginRight: '10px',
                                        // marginTop: '-13px',
                                        // border: ' 1px solid red',
                                    }}
                                    src={file}
                                    onClick={() => {
                                        actionsList(true)
                                    }}
                                ></img>
                                <span className="tooltiptext saveTooltiptext">
                                    {' '}
                                    <p>Open Save Actions</p>
                                </span>
                            </div>
                        )}

                        {webSerial.isConnected ? (
                            <div
                                className="web_button"
                                style={{
                                    position: 'relative',
                                    aspectRatio: '5/3',
                                    width: 'auto',
                                    height: '9vh',
                                }}
                            >
                                <img
                                    src={renderPrgImage('usbON')}
                                    onClick={handleUSB}
                                    style={{
                                        height: '9vh',
                                    }}
                                />
                                <span className="tooltiptext saveTooltiptext">
                                    {' '}
                                    <p>
                                        Device <br />
                                        connectivity
                                    </p>
                                </span>
                            </div>
                        ) : (
                            <div
                                className="web_button"
                                style={{
                                    position: 'relative',
                                    aspectRatio: '5/3',
                                    width: 'auto',
                                    height: '9vh',
                                }}
                            >
                                <img
                                    src={renderPrgImage('usbOFF')}
                                    onClick={handleUSB}
                                    style={{
                                        height: '9vh',
                                    }}
                                />
                                <span className="tooltiptext saveTooltiptext">
                                    {' '}
                                    <p>
                                        Device <br /> connectivity
                                    </p>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        webSerialConnect: (data) => {
            dispatch(webSerialConnect(data))
        },

        showModal: (data) => {
            dispatch(showModal(data))
        },
        deviceMismatch: (data) => {
            dispatch(deviceMismatch(data))
        },
        deviceDetail: (data) => {
            dispatch(deviceDetails(data))
        },
        //this is for hex programming
        DeselectedComponent: (data) => {
            dispatch(selecteInternalAcessories(data))
        },
        graphPlotStorageReset: (data) => {
            dispatch(graphPlotStorage(data))
        },
        //this is for graph plot storage
        setSelectMultipleInternalAccessories: (data) => {
            dispatch({
                type: 'SET_SELECT_INTERNAL_ACCESSORIES_MULTI',
                payload: data,
            })
        },
        logicComponent: (data) => {
            dispatch({ type: 'LOGIC_SELECTION', payload: data })
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProgramHeader)
